import MainPreviewI from '../types.ts';

const init: MainPreviewI['init'] = function () {
    const { isShow } = this.state;
    const startPreview = this.startPreview.current;
    const endPreview = this.endPreview.current;

    if (isShow) {
        if (endPreview) {
            endPreview.addEventListener('canplaythrough', () => {
                if (!this.ready.end) {
                    this.ready.end = true;

                    setTimeout(() => {
                        endPreview.pause();
                        endPreview.currentTime = 0;
                    }, 100);

                    setTimeout(() => {
                        this.setState({ isStart: true }, () => {
                            endPreview.currentTime = 0;
                            endPreview.play();
                        });
                    }, 1000);
                }
            });

            endPreview.play();
        }
    } else if (startPreview && endPreview) {
        const start = () => {
            if (this.ready.start && this.ready.end && !this.ready.process) {
                this.ready.process = true;

                this.start();
            }
        };

        startPreview.addEventListener('canplaythrough', () => {
            this.ready.start = true;

            start();
        });

        startPreview.play();
        endPreview.play();

        endPreview.addEventListener('canplaythrough', () => {
            this.ready.end = true;

            start();
        });
    }
};

export default init;
